import "./About01.css";

function About01() {
  return (
    <div className="About01 section">
      <div className="container">
        <div className="description">
          <h5>ABOUT</h5>
          <h2>The Story begins...</h2>
          <p>
            Zhǐwǔ is a tale of courage, light, and hope in the times of
            darkness. Born from the inspiration by work of Raphael Erba, Zhǐwǔ
            represents the eternal light that guides us through uncertain times.
          </p>
        </div>
        <div className="About01-box">
          <div>
            <h3>Community-Driven</h3>
            <p>
              $AIZEN is run by its community, with token holders having a voice
              in key decisions.
            </p>
          </div>
          <div>
            <h3>Locked LP</h3>
            <p>
              Since the token was launched via pump.fun, the liquidity pool is
              locked and to be never touched forever and ever.
            </p>
          </div>
          <div>
            <h3> Memecoin Fun</h3>
            <p>
              Engage in the vibrant memecoin community with exciting contests,
              giveaways, and social media campaigns.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About01;
